<mat-dialog-content>
  <mat-card-title>{{ 'ecase.explorer.documentList.archive.title' | translate }}</mat-card-title>
  <p>{{ 'ecase.explorer.documentList.archive.confirmation' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="eCase-dialog-action-button-align">
    <button class="eCase-dialog-positive-action-button"
            [disabled]="submitting"
            mat-raised-button
            (click)="onConfirm()">
      {{ 'ecase.explorer.documentList.archive.title' | translate }}
    </button>
    <button class="eCase-dialog-negative-action-button"
            (click)="onClose()"
            mat-raised-button
            mat-dialog-close>
      {{ 'ecase.common.cancel' | translate }}
    </button>
  </div>
</mat-dialog-actions>
